<script>
export default {
  data() {
    return {
      open: false
    }
  }
}
</script>

<template>
  <div class="app-feedback">
      <b-collapse class="panel is-danger"
        :open.sync="open">
        <div slot="trigger"
          class="panel-heading">
          <span>Ton avis compte</span>
          <b-icon class="is-pulled-right" icon="menu-down" />
        </div>
      
        <div class="panel-content pannel-block">
          <div class="content">
            <a class="app-feedback_issue" target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfzWiWdxqYwLWNlfTOQYfI2SovZM1mNQK0wKmPC9nc5LXLZ0Q/viewform">
              <div class="notification">
                <h4 class="title is-6">J'ai rencontré un problème</h4>
                <p>Tu as rencontré un souci sur The Warmup ? Dis-nous tout !</p>
              </div>
            </a>
            <a class="app-feedback_feature" target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfbqzi1Gk_5F22FGs9Ot7aagIvEVc1OXt3kCyHm1-wl0cZBPQ/viewform">
              <div class="notification">
                <h4 class="title is-6">J'ai un feedback</h4>
                <p>Tu as une fonctionnalité ou une amélioration à proposer ? Vas-y</p>
              </div>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
</template>

<style lang="scss">
@import '~bulma/sass/utilities/all';

.app-feedback {
    position: fixed;
    z-index: 100;
    bottom: pxToEm(10);
    left: pxToEm(10);
    width: 250px;

    @include mobile() {
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;

      .panel.is-danger {
        border-radius: 0;
      }
    }

    a {
      display: block;
      text-decoration: none;
      color: inherit;

      &:first-child {
        margin-bottom: pxToEm(10);
      }
    }

    .panel-content {
      padding: pxToEm(20);
    }

    .notification {
      padding: pxToEm(20) pxToEm(20);
      margin-bottom: pxToEm(20);
      border: 1px solid $grey-light;

      &:last-child {
        margin-bottom: 0;
      }

      h4 {
        margin-bottom: pxToEm(10);
        font-weight: 500;
      }

      p {
        font-size: $font-size-s;
        color: $grey;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// AppFeedback.vue?a5733996